import {io} from 'socket.io-client';

// Live signals for the #experience tab. The server only ever sends ids of
// what changed (post:new, post:changed, comment:changed, vote:changed,
// reaction:changed) — views refetch through the REST API, which enforces
// per-viewer visibility. Connection lives only while the tab is open;
// Experience.vue owns connect/disconnect.

let socket = null;

export function connect(token) {
    if (socket) return socket;

    socket = io('/', {
        path: '/app/socket.io',
        auth: {token},
        // websocket with long-polling fallback (hotel wifi); socket.io retries
        // forever by default, which is what we want here.
        transports: ['websocket', 'polling']
    });

    return socket;
}

export function join(regId, cb) {
    if (!socket) return;
    socket.emit('join', {regId}, cb);
}

export function on(event, handler) {
    if (socket) socket.on(event, handler);
}

export function off(event, handler) {
    if (socket) socket.off(event, handler);
}

export function disconnect() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}
